<template>
  <div>
    <p class="step-content__text">
      Installation is
      <span v-if="overChargeSum > 0">not</span>
      possible according to patrititon total price
    </p>
  </div>
  <div class="step-content__row" v-if="overChargeSum > 0">
    <div class="step-content__text">
      <p>Upcharge -</p>
      <span class="red"> too far</span>
    </div>
    <div class="step-content__row inner">
      <CheckboxField v-model="newInstallationStore.isOverchargeSelected" />
      <div class="step-content__input">
        <span>$</span>
        <input
          type="number"
          v-model="changedOverChargeSum"
          @blur="onOverchargeBlur"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from "vue";

import { CheckboxField } from "@/shared";
import { useInstallationStore } from "@/stores/new/installation.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

const newInstallationStore = useInstallationStore();
const estimateStore = useNewEstimateStore();
const estimate = computed(() => estimateStore.estimate);

const overChargeSum = computed(() => newInstallationStore.overChargeSum);
const changedOverChargeSum = computed({
  get: () => newInstallationStore.changedOverChargeSum,
  set: (value) => {
    newInstallationStore.changedOverChargeSum = value;
  },
});

const onOverchargeBlur = () => {
  if (
    !changedOverChargeSum.value ||
    changedOverChargeSum.value < overChargeSum.value
  ) {
    newInstallationStore.changedOverChargeSum = overChargeSum.value;
    estimate.value.overChargeSum = overChargeSum.value;
  } else {
    estimate.value.overChargeSum = changedOverChargeSum.value;
  }
};

watch(
  () => [newInstallationStore.priceWithDiscount],
  () => {
    if (overChargeSum.value > 0) {
      return;
    }
    const finalInstallationSum =
      newInstallationStore.checkInstallationOverChargeNeeded();

    estimate.value.installationSum = finalInstallationSum;
    estimate.value.overChargeSum = overChargeSum.value;
  },
  {
    deep: true,
  },
);

watch(
  () => newInstallationStore.changedOverChargeSum,
  (value) => {
    estimate.value.overChargeSum = value;
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<style scoped>
.step-content__row {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 30%;
  align-items: center;
}
.step-content__row.inner {
  width: 100%;
  display: grid;
  grid-template-columns: 50px 180px;
  align-items: center;
}

.step-content__text {
  display: flex;
  align-items: center;
  column-gap: 10px;

  color: #052141;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.step-content__text .red {
  color: red;
}
.step-content__input {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 10px;

  color: #052141;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.step-content__input input {
  width: 120px;
  height: 35px;

  border-radius: 20px;
  border: 1px solid #f2f2f2;
  background: #fbfbfb;
  text-align: center;
  padding: 0 17px;
}
</style>
